var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutBlackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3889 13.1111L15 9.5M15 9.5L11.3889 5.88889M15 9.5H6.33333M6.33333 3H5.46667C4.25322 3 3.64649 3 3.18302 3.23615C2.77533 3.44388 2.44388 3.77533 2.23615 4.18302C2 4.64649 2 5.25322 2 6.46667V12.5333C2 13.7468 2 14.3535 2.23615 14.817C2.44388 15.2247 2.77533 15.5561 3.18302 15.7638C3.64649 16 4.25322 16 5.46667 16H6.33333",
    stroke: "currentFill",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutBlackIcon);
export default __webpack_public_path__ + "static/media/LogoutBlackIcon.e8ffb83e099ad9205c30f02374f76485.svg";
export { ForwardRef as ReactComponent };